const capabilities = [
  {
    num: "01",
    code: "AI",
    title: "AI Assistants",
    text:
      "Internal or customer-facing assistants that retrieve knowledge, answer questions and support decisions.",
    accent: true,
  },
  {
    num: "02",
    code: "WF",
    title: "Workflow Automation",
    text:
      "Connected systems that reduce repetitive work, handoffs and avoidable operating time.",
  },
  {
    num: "03",
    code: "OP",
    title: "Internal Business Tools",
    text:
      "Purpose-built products for operations, sales, HR, finance and service teams.",
  },
  {
    num: "04",
    code: "DT",
    title: "Data & Intelligence Products",
    text:
      "Insight systems and decision tools that make scattered business data useful.",
  },
  {
    num: "05",
    code: "PX",
    title: "AI Product Prototypes",
    text:
      "Working first versions that help founders and innovation teams test a product opportunity.",
  },
  {
    num: "06",
    code: "CX",
    title: "Customer Experience Products",
    text:
      "Tools that help customers find answers, complete tasks and access services faster.",
  },
];

const BuildCapabilitiesSection = () => {
  return (
    <section className="apl-section apl-section-soft" id="build">
      <div className="apl-shell">
        <div className="apl-section-head apl-reveal">
          <div>
            <div className="apl-eyebrow">What the Lab can build</div>
            <h2>AI products that fit the way work actually happens.</h2>
          </div>
          <p>
            The technology changes with the problem. The goal stays the same:
            build something useful enough to test in the real world.
          </p>
        </div>

        <div className="apl-build-grid">
          {capabilities.map((capability) => (
            <article
              className={`apl-build-card${
                capability.accent ? " apl-accent" : ""
              } apl-reveal`}
              data-code={capability.code}
              key={capability.code}
            >
              <span className="apl-num">{capability.num}</span>
              <h3>{capability.title}</h3>
              <p>{capability.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuildCapabilitiesSection;
